import { Box, Divider, Stack, Typography } from '@mui/material';
import { NoteDetail } from '../../../../Models/ReWeightingModels/Workspace';
import { formatDate } from '../../workspaceFormatting';

export default function NoteContext({ detail }: { detail: NoteDetail }) {
  const { note } = detail;
  return (
    <Box component="aside" aria-label="Upplýsingar um nótu" sx={{ gridArea: 'context', minWidth: 0,
      bgcolor: 'background.default', borderStyle: 'solid', borderWidth: 0, borderLeftWidth: { xl: 1 }, borderBottomWidth: { xs: 1, xl: 0 }, borderColor: 'divider',
      p: { xs: 2, sm: 2.5, xl: 3 } }}>
      <Typography component="h2" fontSize={12} fontWeight={700} color="text.secondary" sx={{ mb: 2 }}>UPPLÝSINGAR NÓTU</Typography>
      <Box component="dl" sx={{ m: 0, display: 'grid', gridTemplateColumns: { xs: '1fr 1fr', sm: 'repeat(3, minmax(0, 1fr))', xl: '1fr' }, gap: { xs: 2, xl: 3 },
        '& dt': { fontSize: 12, color: 'text.secondary', mb: 0.5 }, '& dd': { m: 0, fontSize: 14, fontWeight: 600, overflowWrap: 'anywhere' } }}>
        <Box>
          <Typography component="dt">Skilafrestur</Typography>
          <Typography component="dd" sx={{ color: note.isExpired && !note.isClosed ? 'error.main' : 'text.primary' }}>
            {formatDate(note.dueDate)}
            {note.isExpired && !note.isClosed && <Typography component="span" variant="caption" display="block">Frestur liðinn</Typography>}
          </Typography>
          {note.canEdit && <Typography variant="caption" color="text.secondary" sx={{ display: 'block', mt: 0.5 }}>Sjálfvirk lokun eftir frest.</Typography>}
        </Box>
        <Box><Typography component="dt">Kaupandi</Typography><Typography component="dd">{note.buyerName}</Typography></Box>
        <Box><Typography component="dt">Vigtunarleyfi</Typography><Typography component="dd">{note.permitName || `Leyfi #${note.permitId ?? '—'}`}</Typography></Box>
      </Box>
      <Divider sx={{ my: 2.5, display: { xs: 'none', xl: 'block' } }} />
      <Stack spacing={1} sx={{ display: { xs: 'none', xl: 'flex' } }}>
        <Stack direction="row" justifyContent="space-between" gap={1}><Typography variant="caption" color="text.secondary">Löndun</Typography><Typography variant="caption">#{note.landingId}</Typography></Stack>
        {detail.originalNoteId && <Stack direction="row" justifyContent="space-between" gap={1}><Typography variant="caption" color="text.secondary">Grunnnóta</Typography><Typography variant="caption">#{detail.originalNoteId}</Typography></Stack>}
      </Stack>
    </Box>
  );
}
